import { kmm } from './kmm';

export const removeContinueWatchingItem = (contentId: number): Promise<boolean> =>
  kmm((repo) => repo.removeContinueWatchingItem(contentId));

export default removeContinueWatchingItem;
